import { styled } from '@clickcease/cc-client-components-lib'

const essentialsCard = '> :nth-child(1)'
const insightsCard = '> :nth-child(2)'
const invalidVisitsTrendsAndThreatGroups = '> :nth-child(3)'
const overallDomainsPerformance = '> :nth-child(4)'

export const PaidMarketingHomeStyle = styled('div', {
  // https://cssgrid-generator.netlify.app/
  display: 'grid',
  gridTemplateColumns: 'repeat(6, 1fr)',
  gridTemplateRows: '370px 532px 600px',
  gap: '$10',

  [essentialsCard]: {
    gridArea: '1 / 1 / 2 / 4',
  },
  [insightsCard]: {
    gridArea: '1 / 4 / 2 / 7',
  },
  [invalidVisitsTrendsAndThreatGroups]: {
    gridArea: '2 / 1 / 3 / 7',
  },
  [overallDomainsPerformance]: {
    gridArea: '3 / 1 / 4 / 7',
  },

  variants: {
    noPlatformStatus: {
      true: {
        gridTemplateRows: '332px 532px',
      },
    },
  },
})

export const ProductsWrapper = styled('div', {
  display: 'flex',
  gap: '$5',
  flexGrow: 1,
})

export const SmallTitle = styled('span', {
  marginLeft: '$8',
  fontSize: '$md',
  fontWeight: '$l',
})

export const InsightsWrapper = styled('div', {
  padding: '0 $8',
  overflowX: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',

  '>div': {
    border: '1px solid $veryLightNeutral',
    borderRadius: '$medium',
  },
  '>div>div': {
    justifyContent: 'start',
    boxShadow: '$card',
    orderRadius: '$medium',

    button: {
      marginLeft: '$2',
      marginRight: '$2',
    },
  },
})

export const SmallTitleEssentials = styled(SmallTitle, {
  '@media(max-width:1500px)': {
    marginLeft: 0,
  },
})
